import { combineReducers } from 'redux';
import skuLowStockThreshold, { epics as skuLowStockThresholdEpics } from './skuLowStockThreshold';
import deviceWarehouseList, { epics as deviceWarehouseListEpics } from './deviceWarehouseList';
import consumableWarehouseList, { epics as consumableWarehouseListEpics } from './consumableWarehouseList';

export const epics = [
  ...skuLowStockThresholdEpics,
  ...deviceWarehouseListEpics,
  ...consumableWarehouseListEpics,
];

export default combineReducers({
  skuLowStockThreshold,
  deviceWarehouseList,
  consumableWarehouseList,
});
